import type { Situation } from "../lib/api";
import { formatDate } from "../lib/format";

interface Props {
  situation: Situation;
  size?: "normal" | "large";
  showSince?: boolean;
}

export function SituationStamp({ situation, size = "normal", showSince = false }: Props) {
  const classes = ["stamp", `stamp--${situation.level}`, size === "large" ? "stamp--large" : ""];
  return (
    <span className={classes.join(" ")}>
      {situation.label}
      {showSince && situation.since && (
        <span className="stamp__since">depuis le {formatDate(situation.since, "short")}</span>
      )}
    </span>
  );
}
